module.exports = __webpack_public_path__ + "img/outlook.605ccf5.svg";